import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/South';
import KeyboardArrowUpIcon from '@mui/icons-material/North';

import { SortOptions, SortType } from '../../enums/SORT';
import styles from './SharedContentHeader.module.scss';
import { useDimensions } from '../../helpers';
import DateSortHeader from '../modules/DateSortHeader';

type TSharedWithMeFoldersHeader = {
  onNameClick?: () => void;
  onDateSort?: (_: SortOptions, option: { label: string; value: SortOptions; order: SortType }) => void;
  onSizeClick?: () => void;
  onOwnerSort: () => void;
  sort: SortType;
  noActions?: boolean;
  sortOption: SortOptions | null;
  disableSortBySize: boolean;
};

export const SharedWithMeFoldersHeader: React.FC<TSharedWithMeFoldersHeader> = ({
  onNameClick,
  sort,
  noActions,
  sortOption,
  onSizeClick,
  onOwnerSort,
  disableSortBySize,
  onDateSort,
}) => {
  const { widthD } = useDimensions();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.name}>
          <button type="button" onClick={onNameClick} className={styles.btn}>
            Name
            {sortOption === SortOptions.NAME && sort === SortType.DESC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.NAME && sort === SortType.ASC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
          </button>
        </div>
        <div className={styles.owner} onClick={onOwnerSort}>
          Owner
          {sortOption === SortOptions.OWNER && sort === SortType.DESC && (
            <>
              <KeyboardArrowDownIcon className={styles.arrow} />
            </>
          )}
          {sortOption === SortOptions.OWNER && sort === SortType.ASC && (
            <>
              <KeyboardArrowUpIcon className={styles.arrow} />
            </>
          )}
        </div>
        <div className={styles.access}>Access</div>
        <div className={styles.date}>
          <DateSortHeader
            sortOption={sortOption}
            sort={sort}
            compact={widthD <= 1330}
            onSelect={(value, option) => onDateSort?.(value, option)}
            arrowClassName={styles.arrow}
          />
        </div>
        {disableSortBySize ? (
          <div className={styles.size} style={{ cursor: 'default' }}>
            {widthD > 1330 ? 'File Size' : 'Size'}
          </div>
        ) : (
          <div className={styles.size} onClick={onSizeClick}>
            {widthD > 1330 ? 'File Size' : 'Size'}

            {sortOption === SortOptions.SIZE && sort === SortType.DESC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.SIZE && sort === SortType.ASC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>
        )}
        {!noActions && <div className={styles.actionBtns}>Actions</div>}
      </div>
    </div>
  );
};
